/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type MessageBannerCarousel_messages$ref = any;
export type MessageBanner_viewer$ref = any;
export type MessageBanner_viewer = {
    readonly unregisteredUserMessages?: ReadonlyArray<{
        readonly " $fragmentRefs": MessageBannerCarousel_messages$ref;
    } | null> | null;
    readonly previewMessages?: ReadonlyArray<{
        readonly " $fragmentRefs": MessageBannerCarousel_messages$ref;
    } | null> | null;
    readonly " $refType": MessageBanner_viewer$ref;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "FragmentSpread",
    "name": "MessageBannerCarousel_messages",
    "args": null
  }
];
return {
  "kind": "Fragment",
  "name": "MessageBanner_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "marketingBannerIsFirstTimeVisitor",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "marketingBannerPreviewSetId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "marketingBannerPreviewUserType",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "hasMarketingBannerPreviewVariables",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": "unregisteredUserMessages",
              "name": "messageSet",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "isFirstTimeVisitor",
                  "variableName": "marketingBannerIsFirstTimeVisitor"
                }
              ],
              "concreteType": "MessageSetModule",
              "plural": true,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasMarketingBannerPreviewVariables",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "previewMessages",
          "name": "messageSet",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "setId",
              "variableName": "marketingBannerPreviewSetId"
            },
            {
              "kind": "Variable",
              "name": "userType",
              "variableName": "marketingBannerPreviewUserType"
            }
          ],
          "concreteType": "MessageSetModule",
          "plural": true,
          "selections": (v0/*: any*/)
        }
      ]
    }
  ]
};
})();
(node as any).hash = '126ffb553844df86658da81e74c6f08f';
export default node;
